module.exports = __webpack_public_path__ + "static/media/book-open-solid.fb891530.svg";